import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsAreasAreaRoute extends Route {
  @service store;

  model({ area_id }) {
    return this.store.findRecord('area', area_id);
  }
}

export default instrumentRoutePerformance(SettingsAreasAreaRoute);
